const selectedVariants = {};
const MOBILE_BREAKPOINT = 990;

function formatCardMoney(cents, currencyCode) {
  const currency = currencyCode || window.Shopify?.currency?.active || 'CLP';
  const amount = Number(cents || 0) / 100;

  try {
    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency,
    }).format(amount);
  } catch (error) {
    return new Intl.NumberFormat('es-CL').format(amount);
  }
}

function updateCustomScrollbars(retries = 3) {
  const sidebar = document.getElementById('mobile-bar');
  if (!sidebar) return;

  const scrollables = [
    { list: sidebar.querySelector('.app-cart-sidebar__bags-list'), bar: sidebar.querySelector('.custom-scrollbar[data-for="bags-list"]') },
    { list: sidebar.querySelector('.app-cart-sidebar__list'), bar: sidebar.querySelector('.custom-scrollbar[data-for="reco-list"]') }
  ];

  scrollables.forEach(({ list, bar }) => {
    if (!list || !bar) return;

    // Use a small delay to ensure rendering is complete
    requestAnimationFrame(() => {
      const scrollWidth = list.scrollWidth;
      const clientWidth = list.clientWidth;

      const hasScroll = scrollWidth > clientWidth + 1;

      // Force display if scrollable, but also ensure it's hidden if not
      if (hasScroll) {
        bar.style.setProperty('display', 'block', 'important');
      } else {
        bar.style.display = 'none';
      }

      if (hasScroll) {
        const thumb = bar.querySelector('.custom-scrollbar__thumb');
        if (!thumb) return;

        const visibleRatio = clientWidth / scrollWidth;
        const thumbWidthPercent = Math.max(visibleRatio * 100, 20) || 30;
        thumb.style.width = `${thumbWidthPercent}%`;

        const syncThumb = () => {
          const maxScroll = list.scrollWidth - list.clientWidth;
          if (maxScroll <= 0) return;

          const scrollPercent = list.scrollLeft / maxScroll;
          const trackWidth = bar.clientWidth;
          const thumbWidth = thumb.clientWidth;
          const maxThumbMove = trackWidth - thumbWidth;

          const moveX = scrollPercent * maxThumbMove;
          if (!isNaN(moveX)) {
            thumb.style.transform = `translateX(${moveX}px)`;
          }
        };

        list.removeEventListener('scroll', syncThumb);
        list.addEventListener('scroll', syncThumb, { passive: true });
        syncThumb();
      }
    });
  });

  // If retries left, call again after a short delay to catch late rendering
  if (retries > 0) {
    setTimeout(() => updateCustomScrollbars(retries - 1), 500);
  }
}

// Card Product Carousel Functions
window.cardCarouselNav = function (button, direction) {
  const carousel = button.closest('.card-carousel');
  const slides = [...carousel.querySelectorAll('.card-carousel__slide')].filter(s => getComputedStyle(s).display !== 'none');
  const dots = [...carousel.querySelectorAll('.card-carousel__dot')].filter(d => getComputedStyle(d).display !== 'none');
  const currentIndex = slides.findIndex((s) => s.classList.contains('active'));
  let newIndex;

  if (direction === 'prev') {
    newIndex = currentIndex <= 0 ? slides.length - 1 : currentIndex - 1;
  } else {
    newIndex = currentIndex >= slides.length - 1 ? 0 : currentIndex + 1;
  }

  slides.forEach((s) => s.classList.remove('active'));
  dots.forEach((d) => d.classList.remove('active'));
  slides[newIndex]?.classList.add('active');
  dots[newIndex]?.classList.add('active');
};

window.cardCarouselGoTo = function (dot, index) {
  const carousel = dot.closest('.card-carousel');
  const slides = carousel.querySelectorAll('.card-carousel__slide');
  const dots = carousel.querySelectorAll('.card-carousel__dot');

  slides.forEach((s) => s.classList.remove('active'));
  dots.forEach((d) => d.classList.remove('active'));
  slides[index]?.classList.add('active');
  dots[index]?.classList.add('active');
};

// Swipe support for Card Product Carousel
(function () {
  let startX = 0;
  let startY = 0;
  let isSwipe = false;

  document.addEventListener('touchstart', function (e) {
    const carousel = e.target.closest('.card-carousel');
    if (!carousel) return;
    if (carousel.dataset.cardMediaMode === 'hover') return;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    isSwipe = false;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!startX) return;
    const carousel = e.target.closest('.card-carousel');
    if (!carousel) return;
    if (carousel.dataset.cardMediaMode === 'hover') return;

    const diffX = e.touches[0].clientX - startX;
    const diffY = e.touches[0].clientY - startY;

    if (!isSwipe && Math.abs(diffX) > 10 && Math.abs(diffX) > Math.abs(diffY)) {
      isSwipe = true;
    }

    if (isSwipe) {
      if (e.cancelable) e.preventDefault();
    }
  }, { passive: false });

  document.addEventListener('touchend', function (e) {
    if (!startX || !isSwipe) {
      startX = 0;
      return;
    }
    const carousel = e.target.closest('.card-carousel');
    if (!carousel) return;
    if (carousel.dataset.cardMediaMode === 'hover') return;

    const diffX = e.changedTouches[0].clientX - startX;
    if (Math.abs(diffX) > 40) {
      // Inverted: swipe right (diffX > 0) = prev, swipe left (diffX < 0) = next
      window.cardCarouselNav(carousel, diffX > 0 ? 'prev' : 'next');
    }

    startX = 0;
    isSwipe = false;
  }, { passive: true });
})();

window.toggleVariantSelector = function (element) {
  const currentCard = element.closest('.card-product');
  const wasActive = currentCard.classList.contains('mobile-active');

  document.querySelectorAll('.card-product.mobile-active').forEach(card => card.classList.remove('mobile-active'));

  if (!wasActive) currentCard.classList.add('mobile-active');
};

// Cache de productos ya cargados
const productCache = {};

/**
 * Obtiene los datos de un producto desde Shopify API
 * Usa cache para evitar peticiones repetidas
 */
async function getProductData(handle) {
  // Retornar desde cache si existe
  if (productCache[handle]) {
    return productCache[handle];
  }

  try {
    const response = await fetch(`/products/${handle}.js`);
    if (!response.ok) throw new Error('Product not found');

    const data = await response.json();
    productCache[handle] = data;
    return data;
  } catch (error) {
    console.error('Error fetching product:', error);
    return null;
  }
}

/**
 * Actualiza la tarjeta del producto con los nuevos datos
 */
function updateCard(card, productData, color) {
  const carousel = card.querySelector('.card-carousel');
  const slides = carousel.querySelectorAll('.card-carousel__slide');
  const dots = carousel.querySelectorAll('.card-carousel__dot');

  // Obtener imágenes del producto (hasta 5)
  const images = productData.media.slice(0, 5).map(media => media.src);

  // Actualizar slides del carrusel
  slides.forEach((slide, index) => {
    const img = slide.querySelector('img');
    if (index < images.length && images[index]) {
      if (img) {
        img.src = images[index];
        img.srcset = images[index];
      }
      slide.style.display = "";
      slide.classList.remove('active');
    } else {
      slide.style.display = "none";
      slide.classList.remove('active');
    }
  });

  // Actualizar dots
  dots.forEach((dot, index) => {
    if (index < images.length) {
      dot.style.display = "";
      dot.classList.remove('active');
    } else {
      dot.style.display = "none";
      dot.classList.remove('active');
    }
  });

  // Activar primer slide y dot
  if (slides[0] && images.length > 0) slides[0].classList.add('active');
  if (dots[0] && images.length > 0) dots[0].classList.add('active');

  // Gestionar visibilidad de navegación
  const navBtns = carousel.querySelectorAll('.card-carousel__btn');
  const dotsContainer = carousel.querySelector('.card-carousel__dots');

  if (images.length > 1) {
    navBtns.forEach(btn => btn.style.display = "");
    if (dotsContainer) dotsContainer.style.display = "";
  } else {
    navBtns.forEach(btn => btn.style.display = "none");
    if (dotsContainer) dotsContainer.style.display = "none";
  }

  // Actualizar título
  const titleH4 = card.querySelector('.card-content h4');
  if (titleH4) {
    titleH4.textContent = productData.title.split(' ').slice(0, 4).join(' ');
  }

  // Actualizar variantes
  const variantsContainer = card.querySelector('.variants');
  if (variantsContainer) {
    variantsContainer.innerHTML = productData.variants.map(v => `
      \u003cdiv class="variant-option ${v.option1 === 'Talla única' ? 'talla-unica' : ''} ${v.option1.includes('-') ? 'range-variant' : ''}" 
           data-variant-id="${v.id}" 
           onclick="selectVariant(this, ${productData.id})" 
           ${!v.available ? 'disabled' : ''}
      >
        ${v.option1 === 'Talla única' ? 'Talla Única' : v.option1.replace(/\s*(meses|años)\s*/gi, (match, word) => word.toLowerCase() === 'meses' ? 'M' : 'A')}
      \u003c/div>
    `).join('');
  }

  // Actualizar precios
  const priceContainer = card.querySelector('.card-price');
  if (priceContainer) {
    const price = productData.price;
    const compareAtPrice = productData.compare_at_price;
    const hasDiscount = compareAtPrice && compareAtPrice > price;

    // Shopify devuelve precios en centavos; formateamos con la moneda activa del storefront.
    const currencyCode = priceContainer.dataset.currencyCode;
    const formattedPrice = formatCardMoney(price, currencyCode);
    const formattedComparePrice = compareAtPrice ? formatCardMoney(compareAtPrice, currencyCode) : null;

    if (hasDiscount) {
      priceContainer.innerHTML = `
        \u003cspan class="price offer">${formattedPrice}\u003c/span>
        \u003cspan class="compare">${formattedComparePrice}\u003c/span>
      `;
    } else {
      priceContainer.innerHTML = `
        \u003cspan class="price">${formattedPrice}\u003c/span>
      `;
    }

    // Actualizar badge de oferta
    const offerBadge = card.querySelector('.badge.offer');
    if (hasDiscount) {
      const discountPercent = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
      if (offerBadge) {
        offerBadge.textContent = `-${discountPercent}%`;
        offerBadge.style.display = '';
      } else {
        const cardHeader = card.querySelector('.card-header');
        if (cardHeader) {
          const newBadge = document.createElement('span');
          newBadge.className = 'badge offer';
          newBadge.textContent = `-${discountPercent}%`;
          cardHeader.insertBefore(newBadge, cardHeader.firstChild);
        }
      }
    } else {
      if (offerBadge) {
        offerBadge.style.display = 'none';
      }
    }
  }

  // Actualizar URL del producto
  const carouselLink = carousel.querySelector('.card-carousel__slides');
  if (carouselLink) {
    carouselLink.href = `/products/${productData.handle}`;
  }

  // Actualizar botón de agregar al carrito
  const addToCartBtn = card.querySelector('.add-to-cart');
  if (addToCartBtn) {
    addToCartBtn.setAttribute('onclick', `addToCart(${productData.id})`);
  }
}

/**
 * Función principal para cambiar de producto
 * Ahora usa AJAX en lugar de data attributes
 */
window.changeProduct = async function (swatch) {
  const card = swatch.closest('.card-product');
  const productHandle = swatch.dataset.productHandle;
  const color = swatch.dataset.color;

  if (!productHandle) {
    console.error('Product handle not found');
    return;
  }

  // Agregar estado de carga
  card.classList.add('loading');

  try {
    // Obtener datos del producto (con cache)
    const productData = await getProductData(productHandle);

    if (!productData) {
      console.error('Failed to load product data');
      return;
    }

    // Actualizar la tarjeta con los nuevos datos
    updateCard(card, productData, color);

    // Actualizar swatches activos
    card.querySelectorAll('.swatch').forEach(s => s.removeAttribute('active'));
    swatch.setAttribute('active', '');

  } catch (error) {
    console.error('Error changing product:', error);
  } finally {
    // Remover estado de carga
    card.classList.remove('loading');
  }
};

async function addToCartAndRefresh(variantId) {
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: "cart-drawer,cart-icon-bubble,cart-icon-bubble-mobile"
      })
    });

    const cartData = await response.json();

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartData.sections) {
      cartDrawer.renderContents({ sections: cartData.sections });
    }

    if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'pinflag-custom',
        productVariantId: variantId,
        cartData: cartData
      });
    }

    return cartDrawer;
  } catch (error) {
    console.error('Error al agregar al carrito:', error);
    return null;
  }
}

window.selectVariant = async function (element) {
  if (element.hasAttribute('disabled')) return;

  element.parentElement.querySelectorAll('.variant-option').forEach(v => v.classList.remove('selected'));
  element.classList.add('selected');
  await addToCartAndRefresh(element.dataset.variantId);
};

window.addToCart = async function (productId) {
  const variantId = selectedVariants[productId];
  if (!variantId) return alert('Por favor selecciona una variante');
  await addToCartAndRefresh(variantId);
};

window.scrollCarousel = function (direction, container) {
  const wrapper = container?.querySelector('.cards-wrapper') || document.querySelector('.carousel-container.active .cards-wrapper');
  wrapper?.scrollBy({ left: direction * 410, behavior: 'smooth' });
}

// Función específica para el carrusel de bolsas
window.scrollBagsCarousel = function (direction, bagsContainer) {
  if (bagsContainer) {
    bagsContainer.scrollBy({ left: direction * 410, behavior: 'smooth' });
  }
}

window.toggleCollection = function (collectionId) {
  // This is a legacy function, ideally shouldn't be used with multiple sections
  document.querySelectorAll('.carousel-container, .collection-badges .badge').forEach(el => el.classList.remove('active'));
  document.getElementById(collectionId)?.classList.add('active');
  document.querySelector(`[data-collection-id="${collectionId}"]`)?.classList.add('active');
}

document.addEventListener('change', (e) => {
  if (!e.target.matches('input[type="checkbox"]')) return;
  const form = e.target.closest('form');
  if (!form?.querySelector('input[type="checkbox"]:checked')) return;
  if (form.querySelector('input[name="filter.v.availability"]')) return;
  form.insertAdjacentHTML('beforeend', '<input type="hidden" name="filter.v.availability" value="1">');
});

(() => {
  const handleize = str => str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const getCart = async () => (await fetch('/cart.js')).json();
  const getRecommendations = async (productId) => {
    const data = await (await fetch(`/recommendations/products.json?product_id=${productId}&limit=10`)).json();
    return data.products || [];
  };
  const getCartDrawer = () => document.querySelector('cart-drawer');
  const isMobile = () => window.innerWidth < MOBILE_BREAKPOINT;

  function createProductHTML(product) {
    const { compare_at_price, price, variants, options, url, featured_image, title, vendor } = product;
    const discount = Math.round(((compare_at_price - price) / compare_at_price) * 100);
    const hasDiscount = compare_at_price > 0;
    const first = variants[0];
    const colorOption = options.find(o => o.name.toLowerCase() === 'color');
    const colorValue = colorOption ? first.options[options.indexOf(colorOption)] : first.option2 || first.option1;
    const circleColor = handleize(colorValue);
    const sizeKind = first.option1.toLowerCase().includes('meses') ? 'M' : first.option1.toLowerCase().includes('años') ? 'A' : '';
    const isUnique = first.option1.toLowerCase().includes('talla');

    return `
      <div class="app-cart-reco-item">
        <a href="${url}">
          <img src="${featured_image}" alt="${title}" loading="lazy" height="400px" width="auto">
        </a>
        <div class="app-cart-reco-item__info">
          <p class="app-cart-reco-item__vendor">${vendor}</p>
          <a href="${url}" class="app-cart-reco-item__title">${title}</a>
          <div class="product-option">
            <dd>
              <span class="circle" style="background-color: var(--color-${circleColor})">&nbsp;</span>
              ${colorValue} / ${first.option1}
            </dd>
          </div>
          <span class="reco-subtitle">+ AGREGAR AL CARRO</span>
          <div class="app-cart-reco-item__variants">
            ${variants.map(v => `<span class="reco-variant" id="${v.id}" ${!v.available ? 'disabled' : ''}>${isUnique ? 'Talla Única' : v.option1.split(" ")[0] + sizeKind}</span>`).join('')}
          </div>
        </div>
        <div class="app-cart-reco-item__price">
          <div class="price-wrapper">
            ${hasDiscount ? `<span class="compare-price">$${(compare_at_price / 100).toLocaleString('es-CL')}</span>` : ''}
            <span class="final-price ${hasDiscount ? 'has-discount' : ''}">$${(price / 100).toLocaleString('es-CL')}</span>
          </div>
          ${hasDiscount ? `<div class="badge-offer">-${discount}%</div>` : ''}
        </div>
      </div>`;
  }

  function render(products, cart, list, sourceVendor) {
    if (!list) return;

    const cartIds = cart.items.map(i => i.product_id);
    let filtered = products.filter(p => !cartIds.includes(p.id));
    if (sourceVendor) filtered = filtered.filter(p => p.vendor === sourceVendor);
    filtered = filtered.slice(0, 5);

    list.innerHTML = filtered.length
      ? filtered.map(createProductHTML).join('')
      : '<div class="app-cart-sidebar__loading">No hay recomendaciones</div>';
  }

  async function updateRecommendations(cart = null) {
    const targetId = isMobile() ? 'mobile-bar' : 'desktop-bar';
    const sidebar = document.getElementById(targetId);
    const list = sidebar?.querySelector('.app-cart-sidebar__list');

    if (!cart) cart = await getCart();

    if (!cart.items.length) {
      if (sidebar) sidebar.style.display = 'none';
      return;
    }

    if (sidebar) sidebar.style.display = '';
    if (list) list.innerHTML = '<div class="skeleton-loader">&nbsp;</div>'.repeat(5);

    const products = await getRecommendations(cart.items[0].product_id);
    render(products, cart, list || sidebar?.querySelector('.app-cart-sidebar__list'), cart.items[0].vendor);
    setTimeout(updateCustomScrollbars, 100);
  }

  function initListSwitcher() {
    const sidebar = document.getElementById('mobile-bar');
    if (!sidebar) return;

    const bagsList = sidebar.querySelector('.app-cart-sidebar__bags-list');
    const recoList = sidebar.querySelector('.app-cart-sidebar__list');
    if (!bagsList || !recoList) return;

    bagsList.style.display = 'flex';
    recoList.style.display = 'none';
    document.querySelector('.list-switch-btn[data-list="bags"]')?.classList.add('active');
  }

  window.switchList = function (listType, btn) {
    const sidebar = document.getElementById('mobile-bar');
    if (!sidebar) return;

    const bagsList = sidebar.querySelector('.app-cart-sidebar__bags-list');
    const recoList = sidebar.querySelector('.app-cart-sidebar__list');
    if (!bagsList || !recoList) return;

    document.querySelectorAll('.list-switch-btn').forEach(b => b.classList.remove('active'));
    btn?.classList.add('active');

    bagsList.style.display = listType === 'bags' ? 'flex' : 'none';
    recoList.style.display = listType === 'recommendations' ? 'flex' : 'none';
    setTimeout(updateCustomScrollbars, 50);
  };

  const cartDrawer = getCartDrawer();
  if (cartDrawer) {
    new MutationObserver(mutations => {
      if (mutations.some(m => m.type === 'attributes' && m.attributeName === 'class' && m.target.classList.contains('active'))) {
        setTimeout(() => {
          updateRecommendations();
          initListSwitcher();
          setTimeout(updateCustomScrollbars, 200);
        }, 100);
      }
    }).observe(cartDrawer, { attributes: true });
  }

  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
      if (getCartDrawer()?.classList.contains('active')) {
        setTimeout(() => updateRecommendations(event.cartData), 150);
      }
    });
  }

  // Event listeners específicos para las flechas del carrusel de bolsas
  document.querySelectorAll('.app-cart-sidebar__bags .arrow.left').forEach(arrow => {
    arrow.addEventListener('click', () => {
      const bagsContainer = arrow.closest('.app-cart-sidebar__bags');
      scrollBagsCarousel(-0.3, bagsContainer);
    });
  });

  document.querySelectorAll('.app-cart-sidebar__bags .arrow.right').forEach(arrow => {
    arrow.addEventListener('click', () => {
      const bagsContainer = arrow.closest('.app-cart-sidebar__bags');
      scrollBagsCarousel(0.3, bagsContainer);
    });
  });

  document.addEventListener('click', async (e) => {
    const bagPrice = e.target.closest('.bag-price');
    if (bagPrice) {
      e.preventDefault();
      if (await addToCartAndRefresh(bagPrice.dataset.variantId)) await updateRecommendations();
      return;
    }

    const variant = e.target.closest('.reco-variant');
    if (variant && !variant.hasAttribute('disabled')) {
      variant.closest('.app-cart-reco-item').querySelectorAll('.reco-variant').forEach(v => v.removeAttribute('active'));
      variant.setAttribute('active', '');
      e.preventDefault();
      if (await addToCartAndRefresh(variant.id)) await updateRecommendations();
      return;
    }

    const btn = e.target.closest('.app-cart-reco-item__add');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    if (await addToCartAndRefresh(btn.dataset.variantId)) await updateRecommendations(await getCart());
    btn.disabled = false;
  });

  window.addEventListener('resize', () => updateCustomScrollbars(1));
  window.addEventListener('orientationchange', () => setTimeout(() => updateCustomScrollbars(2), 500));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initListSwitcher();
      updateCustomScrollbars(2);
    });
  } else {
    initListSwitcher();
    updateCustomScrollbars(2);
  }
})();

(() => {
  let removed = false, cachedNode = null, cachedParent = null, cachedNextSibling = null;

  function handleResize() {
    const isMobile = window.innerWidth < MOBILE_BREAKPOINT;
    const el = document.querySelector('#desktop-icons.header__icons');

    if (isMobile && el && !removed) {
      cachedNode = el;
      cachedParent = el.parentNode;
      cachedNextSibling = el.nextSibling;
      el.remove();
      removed = true;
    } else if (!isMobile && removed && cachedNode && cachedParent) {
      cachedParent.insertBefore(cachedNode, cachedNextSibling);
      removed = false;
    }
  }

  document.addEventListener('DOMContentLoaded', handleResize);
  window.addEventListener('resize', handleResize);
})();

// ============================================
// Collection Navigation Tracking for Breadcrumbs
// ============================================
(() => {
  // Track product clicks from collection pages
  document.addEventListener('click', (e) => {
    const productLink = e.target.closest('.card-product a[href*="/products/"]');

    if (productLink) {
      // Check if we're on a collection page
      const isCollectionPage = window.location.pathname.includes('/collections/');

      if (isCollectionPage) {
        // Extract collection handle from URL
        const pathParts = window.location.pathname.split('/');
        const collectionIndex = pathParts.indexOf('collections');

        if (collectionIndex !== -1 && pathParts[collectionIndex + 1]) {
          const collectionHandle = pathParts[collectionIndex + 1];

          // Get collection title from page (try multiple selectors)
          let collectionTitle = '';

          // Try to get from collection banner heading
          const bannerHeading = document.querySelector('.collection-hero__title, .collection__title, h1');
          if (bannerHeading) {
            collectionTitle = bannerHeading.textContent.trim();
          }

          // Fallback: format handle as title
          if (!collectionTitle) {
            collectionTitle = collectionHandle
              .split('-')
              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ');
          }

          // Store in sessionStorage
          sessionStorage.setItem('productFromCollection', 'true');
          sessionStorage.setItem('collectionHandle', collectionHandle);
          sessionStorage.setItem('collectionTitle', collectionTitle);
        }
      } else {
        // Clear collection tracking if not on a collection page
        sessionStorage.removeItem('productFromCollection');
        sessionStorage.removeItem('collectionHandle');
        sessionStorage.removeItem('collectionTitle');
      }
    }
  });

  // Clear collection tracking when navigating to home
  if (window.location.pathname === '/' ||
    window.location.pathname === '/index' ||
    window.location.pathname.includes('/index')) {
    sessionStorage.removeItem('productFromCollection');
    sessionStorage.removeItem('collectionHandle');
    sessionStorage.removeItem('collectionTitle');
  }
})();

// Judge.me badge text formatter
// Replaces "X reseñas" with "(X)" and hides the text when there are no reviews
(function () {
  function formatBadgeText(textEl) {
    const badge = textEl.closest('.jdgm-prev-badge');
    if (!badge) return;
    const count = parseInt(badge.dataset.numberOfReviews, 10);
    if (isNaN(count) || count === 0) {
      if (textEl.style.display !== 'none') {
        textEl.style.display = 'none';
      }
    } else {
      const newText = `(${count})`;
      if (textEl.textContent !== newText) {
        textEl.textContent = newText;
      }
      if (textEl.style.display !== '') {
        textEl.style.display = '';
      }
    }
  }

  function processAll() {
    document.querySelectorAll('.jdgm-prev-badge__text').forEach(formatBadgeText);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processAll);
  } else {
    processAll();
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          if (node.classList?.contains('jdgm-prev-badge__text')) {
            formatBadgeText(node);
          } else {
            node.querySelectorAll?.('.jdgm-prev-badge__text').forEach(formatBadgeText);
          }
        });
      } else if (mutation.type === 'characterData') {
        const el = mutation.target.parentElement;
        if (el?.classList?.contains('jdgm-prev-badge__text')) {
          formatBadgeText(el);
        }
      } else if (mutation.type === 'attributes') {
        if (mutation.target.classList?.contains('jdgm-prev-badge')) {
          const textEl = mutation.target.querySelector('.jdgm-prev-badge__text');
          if (textEl) formatBadgeText(textEl);
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['data-number-of-reviews'],
  });
})();